<template>
  <div class="pages-common-slim-banner">
    <div class="row-190-40 pages-common-slim-banner__wrap">
      <div v-if="props.data.text" class="pages-common-slim-banner__text text-corpo-l is-xlight" v-html="props.data.text" />

      <img v-if="props.data.image?.url" class="pages-common-slim-banner__img" :src="props.data.image.url" :alt="props.data.image?.alt" :width="props.data.image?.width" :height="props.data.image?.height">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonSlimBanner',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})
</script>

<style lang="scss">
@import './style.scss';
</style>
